import React, { useState } from 'react';
import '../ProductStatusFilter.css';
import { FormControlLabel, Checkbox, Button, IconButton, Tooltip, CircularProgress } from '@material-ui/core';
import { useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import RefreshIcon from '@material-ui/icons/Refresh';

function TeamFilter({ handleFilters, refreshData }) {
    const { register, handleSubmit } = useForm();
    const history = useHistory();
    const [isRefreshLoading, setIsRefreshLoading] = useState(false);

    const handleChangedFilter = (data) => {
        handleFilters(data);
    }

    const handleRefreshBtn = () => {
        setIsRefreshLoading(true);
        refreshData();
        setIsRefreshLoading(false);
    }

    return (
        <>
            <form onChange={handleSubmit(handleChangedFilter)}>
                <div className="allProducts__productStatusFilter">
                    <div className="allProducts__productStatusContent allProducts__createStatusContent">
                        <Button 
                            variant="contained" 
                            className="employerIndex__createPostBtn employerIndex__createProduct"
                            onClick={() => history.push('/retailer/add-member')}>Add New Member</Button>
                    </div>
                    <div className="allProducts__productStatusContent allProducts__importProduct ml-5">
                        <Button 
                            variant="contained" 
                            className="employerIndex__createPostBtn"
                            onClick={() => history.push('/retailer/import-member')}>Import From Excel</Button>
                    </div>
                    <div className="allProducts__productStatusContent">
                        <Tooltip title="Refresh with new data" placement="top">
                            <IconButton 
                                color="secondary"
                                onClick={handleRefreshBtn}>
                                {isRefreshLoading ? <CircularProgress size={16} /> : <RefreshIcon fontSize='large' />}
                            </IconButton>
                        </Tooltip>
                    </div>
                </div>
            </form>
        </>
    )
}

export default TeamFilter
